'use client';
import { useCallback, useSyncExternalStore } from 'react';

const getServerSnapshot = () => false;

/**
 * A media query as React state. Unlike an effect-based hook it already knows
 * the answer on the first client render, so a layout that branches on it never
 * paints the wrong branch first. On the server it always reports false.
 */
export const useMediaQuery = (query: string) => {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const media = window.matchMedia(query);

      media.addEventListener('change', onChange);

      return () => media.removeEventListener('change', onChange);
    },
    [query],
  );

  const getSnapshot = useCallback(
    () => window.matchMedia(query).matches,
    [query],
  );

  return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
